<template>
  <el-main>
    <el-row :gutter="10" type="flex" justify="left">
      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <card-total
          text="Clientes con App"
          icon="el-icon-mobile-phone success-text"
          :total="TotalUsoApp"
          :loading.sync="loading"
        />
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <card-total
          text="Clientes sin App"
          icon="el-icon-mobile-phone danger-text"
          :total="TotalSinApp"
          :loading.sync="loading"
        />
      </el-col>

      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <card-total
          text="Clientes Activos en el Portal"
          icon="el-icon-s-platform success-text"
          :total="TotalActivoPortal"
          :loading.sync="loading"
        />
      </el-col>
      <!--
      <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
        <card-total
          text="Clientes inactivos en el Portal"
          icon="el-icon-s-platform danger-text"
          :total="TotalInactivoPortal"
          :loading.sync="loading"
        />
      </el-col>
      -->
    </el-row>

    <el-row :gutter="60" type="flex" class="row-bg rowx" justify="end">
      <el-col>
        <label for="sele" class="label">Filtrar por : </label>
        <el-select
          id="sele"
          v-model="CustomerService"
          @change="AppFilter"
          :clearable="true"
          placeholder="Servicio al Cliente"
        >
          <el-option
            v-for="item in optionsApp"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          id="sele"
          v-model="CustomerService"
          @change="AppFilter"
          :clearable="true"
          placeholder="Vendedor"
        >
          <el-option
            v-for="item in optionsApp"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <rabbey-toolbox
          class="mt-0 toolbox"
          :filterables="true"
          @filter-search="onFilterSearch"
        >
          <div class="mr-5">
            <el-button
              type="primary"
              icon="el-icon-refresh"
              size="mini"
              :loading.sync="loading"
              @click="RefreshPage"
              >Actualizar</el-button
            >
          </div>
        </rabbey-toolbox>
      </el-col>
    </el-row>

    <el-row>
      <rabbey-table-3
        ref="ReportAppTable"
        :loading.sync="loading"
        :columns="columnas"
        :data.sync="Resultado"
        :max-height="700"
        :page-sizes="[10, 30, 50, 100, 500, 1000, 2000]"
      />
      <ReportAppCustomerServiceDetail ref="AppCostumerServiceDetail" />
    </el-row>
  </el-main>
</template>

<script>
//import axios from "axios";
import { formatPhoneNumber } from "@/utils.js";
//import ColorTagsinLineFormatter from "@/components/functionals/ColorTagsinLineFormatter";
//import CompanyFormatter from "@/components/functionals/CompanyFormatter.vue";
import CardTotal from "@/components/CardTotalOriginal.vue";
import ReportAppCustomerServiceDetail from "@/components/customer_service/reports/ReportAppCustomerServiceDetail.vue";
import ReportTerminalsHyperLink from "@/components/functionals/ReportTermianlsHyperLink.vue";

export default {
  name: "ReportAppCustomerService",

  data() {
    return {
      loading: false,
      Resultado: [],
      columnas: [
        {
          prop: "CustomerCode",
          label: "Codigo Clinte",
          width: 150,
          align: "center",
          fixed: true,
          sortable: true
        },
        {
          prop: "CustomerName",
          label: "Nombre del Clinte",
          width: 350,
          sortable: true
        },
        {
          prop: "CustomerPhone",
          label: "Teléfono del Clinte",
          width: 170,
          sortable: true,
          formatter: (row) => formatPhoneNumber(row.CustomerPhone)
        },
        /*
        {
          prop: "CustomerEmail",
          label: "Email del Cliente",
          sortable: true,
          width: 250
        },
        */

        {
          prop: "CustomerServiceName",
          label: "Servicio al Cliente",
          sortable: true,
          width: 160
        },
        {
          prop: "SalesPersonName",
          label: "Vendedor",
          sortable: true,
          width: 150
        },

        {
          prop: "CantContactsWithApp",
          label: "Contactos con App",
          sortable: true,
          width: 170,
          align: "center",
          cellAtrrs: {
            OpenTerminalsDetail: this.OpenContactsDetail
          },
          formatter: ReportTerminalsHyperLink
          //formatter: ColorTagsinLineFormatter
        },
        {
          prop: "CantContactsWithoutApp",
          label: "Contactos sin App",
          sortable: true,
          width: 170,
          align: "center",
          cellAtrrs: {
            OpenTerminalsDetail: this.OpenContactsDetail
          },
          formatter: ReportTerminalsHyperLink
          //formatter: ColorTagsinLineFormatter
        },
        {
          prop: "CantContactPortalWebActive",
          label: "Activo en el Portal",
          sortable: true,
          width: 170,
          align: "center",
          cellAtrrs: {
            OpenTerminalsDetail: this.OpenContactsDetail
          },
          formatter: ReportTerminalsHyperLink
          //formatter: ColorTagsinLineFormatter
        }
        /*
        {
          prop: "CantContactPortalWebInactive",
          label: "Inactivo en el Portal",
          sortable: true,
          width: 150,
          align: "center",
          cellAtrrs: {
            OpenTerminalsDetail: this.OpenContactsDetail
          },
          formatter: ReportTerminalsHyperLink
          //formatter: ColorTagsinLineFormatter
        },
        */
        /*
        {
          prop: "EstadoPortalWeb",
          label: "Estado en el Portal",
          sortable: true,
          width: 170,
          align: "center",
          formatter: ColorTagsinLineFormatter
        },
        {
          prop: "CodigoCompania",
          label: "Cliente de la Empresa",
          sortable: true,
          width: 190,
          align: "center",
          formatter: CompanyFormatter
        },
        {
          prop: "UserRole",
          label: "Rol de usuario",
          sortable: true,
          width: 150,
          align: "center",
          formatter: CompanyFormatter
        }
        */
      ]
    };
  },
  components: {
    CardTotal,
    ReportAppCustomerServiceDetail
  },
  beforeCreate() {
    this.loading = true;
  },
  created() {
    this.loading = true;
    this.GetClientWithOrWithoutApp();
  },
  computed: {
    TotalUsoApp() {
      let cuenta = 0;
      this.Resultado.forEach((item) => {
        if (item.UsoApp === true) {
          cuenta += 1;
        }
      });
      return cuenta;
    },
    TotalSinApp() {
      let cuenta = 0;
      this.Resultado.forEach((item) => {
        if (item.UsoApp === false) {
          cuenta += 1;
        }
      });
      return cuenta;
    },
    TotalActivoPortal() {
      return this.Resultado.map(
        (item) => item.CantContactPortalWebActive
      ).reduce((a, b) => a + b);
    },
    TotalInactivoPortal() {
      return this.Resultado.map(
        (item) => item.CantContactPortalWebInactive
      ).reduce((a, b) => a + b);
    }
  },
  methods: {
    GetClientWithOrWithoutApp() {
      this.loading = true;
      var self = this;
      const ApiUrl = "/api/customers/ClientWithOrWithoutApp";
      this.$http
        .get(ApiUrl, { timeout: 3000000 })
        .then((resp) => {
          let { data } = resp;

          let ClienteArray = [];

          data.forEach((cliente) => {
            let usoapp = Boolean;
            let TotalContacts = Number(cliente.ContactsWithOrWithoutApp.length);
            let ContactsWithApp = cliente.ContactsWithOrWithoutApp.filter(
              (Contact) => Contact.LoginQTY > 0
            );
            let ContactsWithoutApp = cliente.ContactsWithOrWithoutApp.filter(
              (Contact) => Contact.LoginQTY <= 0
            );
            let ContactPortalWebActive =
              cliente.ContactsWithOrWithoutApp.filter(
                (Contact) =>
                  Contact.EstadoProtalWeb > 0 && Contact.EstadoProtalWeb != null
              );

            let ContactPortalWebInactive =
              cliente.ContactsWithOrWithoutApp.filter(
                (Contact) =>
                  Contact.EstadoProtalWeb == null ||
                  Contact.EstadoProtalWeb == 0
              );

            ContactPortalWebInactive.forEach((contact) => {
              if (contact.ContactPortalWebInactive == null) {
                contact.ContactPortalWebInactive = 0;
              }
            });

            if (cliente.LoginQTY > 0) {
              usoapp = true;
            } else {
              usoapp = false;
            }
            ClienteArray.push({
              UsoApp: usoapp,
              TotalContacts: TotalContacts,
              ContactsWithApp: ContactsWithApp,
              ContactsWithoutApp: ContactsWithoutApp,
              CantContactsWithApp: ContactsWithApp.length,
              CantContactsWithoutApp: ContactsWithoutApp.length,
              ContactPortalWebActive: ContactPortalWebActive,
              ContactPortalWebInactive: ContactPortalWebInactive,
              CantContactPortalWebActive: ContactPortalWebActive.length,
              CantContactPortalWebInactive: ContactPortalWebInactive.length,

              ...cliente
            });
          });

          self.Resultado = ClienteArray;
        })
        .catch((error) => {
          console.error("Error: ", error);
        })
        .finally(() => {
          self.loading = false;
        });
    },

    /*
    getContactsbyCustomer() {
      this.loading = true;
      this.items = [];
      this.$http
        .get("/api/contacts/GetContactByCustomerCode", {
          params: {
            customerCode: this.clientCode,
            companyCode: this.currentCompany
          }
        })
        .then(({ data }) => {
          this.items = data;
        })
        .catch(error => {
          this.$message.error("Error al consultar los contratos");
          console.error(error);
          this.items = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    */
    OpenContactsDetail(row, type) {
      this.$refs.AppCostumerServiceDetail.show(row, type);
    },

    onFilterSearch(query) {
      this.$refs.ReportAppTable.filterData(query);
      return;
    },
    RefreshPage() {
      this.GetClientWithOrWithoutApp();
    }
  }
};
</script>

<style scoped></style>
